import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";
import { ACTION_ROW_HEIGHT, END_OF_LIST_SPACER, GO_TO_TOP_MIN_ROWS } from "./rowConstants";

const EndOfListRow = ({ hasNextPage, dataLength, columnCount, classes, onGoToTop }) => {
	const { t } = useTranslation();
	if (hasNextPage || dataLength === 0) return null;
	const isLarge = dataLength >= GO_TO_TOP_MIN_ROWS;
	return (
		<ModelTaskTableBodyRow
			height={isLarge ? ACTION_ROW_HEIGHT : END_OF_LIST_SPACER}
			columnCount={columnCount}
			className={isLarge ? classes.tableAction : undefined}
			onClick={isLarge ? onGoToTop : undefined}
		>
			{isLarge ? t("action.goToTop") : null}
		</ModelTaskTableBodyRow>
	);
};

EndOfListRow.propTypes = {
	hasNextPage: PropTypes.bool.isRequired,
	dataLength: PropTypes.number.isRequired,
	columnCount: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
	onGoToTop: PropTypes.func.isRequired,
};

export default EndOfListRow;
